export const eventer = () => {
  const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
  return window[eventMethod];
};

export const eventRemover = () => {
  const method = window.removeEventListener ? 'removeEventListener' : 'detachEvent';
  return window[method];
};

export const messageEvent = () => {
  const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
  return eventMethod === 'attachEvent' ? 'onmessage' : 'message';
};

export const messageCloser = (win) => new Promise((resolve) => {
  let intervalId = 0;

  const poller = () => {
    try {
      if (win.closed) {
        clearInterval(intervalId);
        resolve();
      }
    } catch (e) {
      // In some cross-origin scenarios, accessing win.closed might throw
      // or be blocked by Cross-Origin-Opener-Policy.
      // We ignore these errors and keep polling, assuming the window
      // will eventually be closed or the policy will allow access.
    }
  };

  intervalId = setInterval(poller, 1000);
});
